import { OrganizationRoles } from "toptaal-shared"

export type Permissions = "create" | "read" | "update" | "delete"

export type Entities =
  | "students"
  | "studentRegistrations"
  | "contacts"
  | "projects"
  | "groups"
  | "organization"
  | "contactStudentConnection"
  | "correspondence"
  | "studentCorrespondence"
  | "groupCorrespondence"
  | "projectCorrespondence"

export const ROLE_PERMISSIONS: {
  [role in OrganizationRoles]: Partial<Record<Entities, Permissions[]>>
} = {
  customer_manager: {
    students: ["read", "update"],
    studentRegistrations: ["read", "update"], // TODO: scope to own registrations only
    contacts: ["read"],
    projects: ["read"],
    groups: ["read"],
    organization: ["read"],
    contactStudentConnection: [],
    correspondence: ["create", "read", "update"],
    studentCorrespondence: ["create", "read", "update"],
    groupCorrespondence: ["create", "read", "update"],
    projectCorrespondence: [],
  },
  admin: {
    students: ["create", "read", "update"],
    studentRegistrations: ["create", "read", "update"],
    contacts: ["create", "read", "update", "delete"],
    projects: ["read"],
    groups: ["read"],
    organization: ["read", "update"],
    contactStudentConnection: ["read", "create", "update"],
    correspondence: ["create", "read", "update"],
    studentCorrespondence: ["create", "read", "update"],
    groupCorrespondence: ["create", "read", "update"],
    projectCorrespondence: ["create", "read", "update"],
  },
} as const
